import React from "react";

function Feedback() {
  return (
    <div id="feedback" className="product d-grid">
      <div className="desktop-image-container image-container">
        <img src="/assets/business/feedback.png" />
      </div>

      <div className="info-container">
        <h3 className="title mb-0 ">Feedback</h3>

        <h4 className="statement mb-0">One Link, Unlimited Responses</h4>

        <p className="paragraph mb-0">
          Receive quantitative data on each stylist's performance. Turn feedback
          data into customer- centric decisions
        </p>

        <a href="#create-free-account" className="border-0">
          Create Free Account
        </a>
      </div>

      <div className="mobile-image-container image-container">
        <img src="/assets/business/feedback.png" />
      </div>
    </div>
  );
}

export default Feedback;
